import { GetAepPsychosocialResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetAepPsychosocialResponse } from '@/types/Psychosocial';

export class GetAepPsychosocialMapper {
	constructor(private readonly data: GetAepPsychosocialResponseDTO) {}

	toDomain(): GetAepPsychosocialResponse {
		return this.data;
	}
}
